import React from "react";
import AdminLayout from "./AdminLayout";
import UserManagement from "../../components/Admin/UserManagement";

const UsersPage = () => {
  return (
    <AdminLayout>
      <UserManagement />
    </AdminLayout>
  );
};

export default UsersPage;
